import {AuthClientTokens} from '@react-keycloak/core';
import {isEmpty} from 'lodash';

const ACCESS_TOKEN_PROPERTY = 'accessToken';
const DEFAULT_TOKEN_TYPE = 'Bearer';

export function loadAccessToken(): string | null {
  return sessionStorage.getItem(ACCESS_TOKEN_PROPERTY);
}

export function saveAccessToken(tokens: AuthClientTokens) {
  if (tokens.token) {
    // save new token in storage
    sessionStorage.setItem(ACCESS_TOKEN_PROPERTY, tokens.token);
  } else {
    // new token is not defined, remove old token from storage
    sessionStorage.removeItem(ACCESS_TOKEN_PROPERTY);
  }
}

export function resetAccessToken() {
  sessionStorage.removeItem(ACCESS_TOKEN_PROPERTY);
}

export function formatAuthorizationToken(accessToken: string, tokenTypeIncluded = false): string {
  return (tokenTypeIncluded ? accessToken : `${DEFAULT_TOKEN_TYPE} ${accessToken}`) || '';
}

export function getAccessTokenValue(): string | null {
  const accessToken = loadAccessToken();
  let resultToken;
  if (accessToken && !isEmpty(accessToken)) {
    resultToken = formatAuthorizationToken(accessToken);
  }
  return resultToken;
}
